import { init as initApm, ApmBase } from '@elastic/apm-rum';

let apmInstance: ApmBase | null = null;

export const initializeApm = (
  serviceName: string,
  serverUrl: string,
  environment: string,
  serviceVersion: string = ''
) => {
  if (typeof window !== 'undefined' && !apmInstance) {
    try {
      apmInstance = initApm({
        serviceName,
        serverUrl,
        serviceVersion,
        environment,
        // Set the active property to true to record transactions right away
        active: true,
        // Distributed tracing settings
        distributedTracing: true,
        // Capture route changes automatically
        pageLoadTransactionName: location.pathname,
        // Capture console logs, XHRs, and other metrics
        errorThrottleLimit: 10,
        transactionThrottleLimit: 20,
        logLevel: environment === 'development' ? 'debug' : 'error',
      });
      
      console.log(`APM initialized for environment: ${environment}`);
      return apmInstance;
    } catch (error) {
      console.error('Error initializing APM:', error);
      return null;
    }
  }
  
  return apmInstance;
};

export const getApm = () => apmInstance;

export const captureError = (error: Error, customContext?: Record<string, any>) => {
  if (!apmInstance) {
    console.warn('APM is not initialized. Error not captured:', error);
    return;
  }

  try {
    apmInstance.captureError(error);
  } catch (captureError) {
    console.error('Failed to capture error with APM:', captureError);
  }
};

export const startTransaction = (name: string, type: string) => {
  if (!apmInstance) {
    console.warn('APM is not initialized. Transaction not started:', name);
    return null;
  }

  return apmInstance.startTransaction(name, type);
};

export const setUserContext = (userId: string, username?: string, email?: string) => {
  if (!apmInstance) {
    console.warn('APM is not initialized. User context not set.');
    return;
  }

  apmInstance.setUserContext({
    id: userId,
    username,
    email,
  });
};

export default {
  initialize: initializeApm,
  getInstance: getApm,
  captureError,
  startTransaction,
  setUserContext,
}; 